import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_app_bar = _resolveComponent("main-app-bar")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_main_app_bar, {
        elevation: "0",
        "app-bar-color": "",
        "app-bar-text-color": ""
      }),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("span", null, "Fejlesztés alatt!!", -1)
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}